import { UPDATE_REGISTER_DRAWER, SET_DRAWERS } from './chunk-HIHJG2ZA.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/register/drawers/reducer.ts
var drawersReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_DRAWERS:
      return action.payload;
    case UPDATE_REGISTER_DRAWER:
      return __spreadProps(__spreadValues({}, state), {
        [action.payload.id]: action.payload
      });
    default:
      return state;
  }
};
var reducer_default = drawersReducer;

export { reducer_default };
